<template>
  <section class="worldWeather">
    <div class="header">
      <div class="inner">
        <SectionTitle title="世界各地の天気" />
        <div class="select">
          <select v-model="selectedArea">
            <option
              v-for="item in areaList"
              :key="item.key"
              :value="item.key"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="search">
        <div class="search__content">
          <button class="search__button" />
          <input
            v-model="keyword"
            type="search"
            placeholder="国名・都市名で検索"
          >
          <button class="search__button" />
        </div>
        <SearchPointCandidate
          v-show="keyword !== ''"
          :result="result"
        />
      </div>
    </div>
    <div class="block">
      <div class="category">
        <p class="category__title">
          エリア
        </p>
        <div class="category__content">
          <button
            v-for="item in areaList"
            :key="item.key"
            :data-category="item.key"
            :data-selected="item.key === selectedArea"
            class="category__text"
            @click="selectedArea = item.key"
          >
            {{ item.text }}
          </button>
        </div>
      </div>
      <div class="list">
        <template
          v-for="item in topArea[selectedArea]"
          :key="item"
        >
          <template v-if="item !== routePointId">
            <NuxtLink
              :to="isExternalLink ? `${runtimeConfig.app.baseURL}${item.replace(/^\//, '')}` : item"
              class="link"
              :external="isExternalLink"
            >
              {{ searchPointList[item].point_ja }}<span class="note">（{{ searchPointList[item].country_ja }}）</span>
            </NuxtLink>
          </template>
          <template v-else>
            <div
              class="link"
              @click="scrollToTop"
            >
              {{ searchPointList[item].point_ja }}<span class="note">（{{ searchPointList[item].country_ja }}）</span>
            </div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useWorldPointSearch } from '~/composables/useWorldPointSearch'
import topArea from '~/data/table/top_area.json'
import searchPointList from '~/data/table/search_point_list.json'

const route = useRoute()
const routePointId = route.path

const { keyword, result } = useWorldPointSearch({ searchPointList })

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const areaList = [
  { key: 'all', text: 'すべて' },
  { key: '1', text: 'アジア' },
  { key: '2', text: '東南アジア' },
  { key: '3', text: '南アジア' },
  { key: '4', text: '中東' },
  { key: '5', text: 'ヨーロッパ' },
  { key: '6', text: 'オセアニア・太平洋' },
  { key: '7', text: '北アメリカ' },
  { key: '8', text: '中南米' },
  { key: '9', text: 'アフリカ' }
]

const selectedArea = ref('all')

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)
</script>

<style lang="scss" scoped>
.worldWeather {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }
    .select {
      border-radius: 4px;
      background-color: #EEF1F8;
      color: #000;
      font-size: 14px;
      line-height: 1em;
      background-image: url('~/assets/images/common/icon_arrow_bottom.svg');
      background-size: 11px;
      background-repeat: no-repeat;
      background-position: right 5px center;
      select {
        padding: 5px 35px 5px 5px;
        outline: none;
        cursor: pointer;
      }
    }
  }
  .search {
    position: relative;
    &__content {
      position: relative;
      border-radius: 100vmax;
      border: 1px solid #3569C0;
      background-color: #FFF;
      overflow: hidden;
      z-index: 2;
    }
    &__button {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 100%;
      background-color: #3569C0;
      background-image: url('~/assets/images/common/icon_search_white.svg');
      background-position: left 8px center;
      background-size: 20px;
      background-repeat: no-repeat;
      border-left: solid 1px #3569C0;
    }
    input {
      display: block;
      width: 100%;
      padding: 3px 40px 3px 10px;
      color: #303030;
      font-size: 16px;
      font-weight: 600;
      line-height: 33px;
      outline: none;
      touch-action: manipulation;
    }
  }
  .block {
    display: flex;
    align-items: flex-start;
    gap: 25px;
    .category {
      display: none;
      flex-direction: column;
      width: 150px;
      border: 1px solid #CCC;
      &__title {
        text-align: center;
        padding-block: 10px;
        background-color: #EEF1F8;
        border-bottom: 1px solid #CCC;
        color: #101010;
        font-size: 15px;
        font-weight: 600;
        line-height: 1em;
      }
      &__content {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
      }
      &__text {
        padding: 5px 12px;
        color: #3569C0;
        font-size: 15px;
        font-weight: 600;
        line-height: 22px;
        border-bottom: solid 1px #ccc;
        text-align: left;
        cursor: pointer;
        &[data-selected='true'] {
          color: #303030;
          background-color: #EEF1F8;
          border-bottom: none;
          pointer-events: none;
        }
      }
    }
  }
  .list {
    display: flex;
    flex: 1;
    flex-direction: column;
    max-height: 400px;
    overflow-y: scroll;
    border: 1px solid #ccc;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 100vmax;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #438fec;
    }
    .link {
      padding-block: 8px;
      padding: 9px 8px 6px;
      color: #3569C0;
      font-size: 15px;
      font-weight: 600;
      line-height: 1em;
      &:not(:last-child) {
        border-bottom: 1px solid #ccc;
      }
    }
    .note {
      color: #606060;
      font-size: 10px;
      font-weight: 600;
    }
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
    .search {
      &__button {
        transition: .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
    .block {
      .category {
        &__text {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
    }
  }
}
.main {
  .worldWeather {
    @media screen and (min-width: 830px) {
      .header {
        flex-direction: row;
        justify-content: space-between;
        .select {
          display: none;
        }
      }
      .search {
        width: 50%;
      }
      .block {
        .category {
          display: flex;
        }
      }
      .list {
        max-height: 500px;
      }
    }
  }
}
</style>
